import {
  formatSplitCostingPathCode,
  getVisibleSplitCostingPathColumns,
  type SplitCostingRow,
} from "../utils";
import styles from "./SplitCostingImportRowsTable.module.css";

function formatDateCell(value: string | null): string {
  return value ?? "—";
}

export interface SplitCostingImportRowsTableProps {
  rows: SplitCostingRow[];
  /** Accessible name for the scrollable table region. */
  ariaLabel: string;
}

/**
 * Read-only grid of parsed split costing rows — upload preview on `UploadScreen`.
 */
export function SplitCostingImportRowsTable({
  rows,
  ariaLabel,
}: SplitCostingImportRowsTableProps) {
  const pathColumns = getVisibleSplitCostingPathColumns(rows);

  return (
    <div
      className={styles.tableWrapper}
      role="region"
      aria-label={ariaLabel}
      tabIndex={0}
    >
      <table className={styles.table}>
        <thead>
          <tr>
            <th scope="col">Employee code</th>
            <th scope="col">Percentage</th>
            {pathColumns.map((column) => (
              <th key={column.level} scope="col">
                {column.label}
              </th>
            ))}
            <th scope="col">Start date</th>
            <th scope="col">End date</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.fileRow}-${row.employeeCode}-${row.apportionedPercentage}`}>
              <td className={styles.cell}>{row.employeeCode}</td>
              <td className={styles.cell}>
                {row.apportionedPercentage.replace(/%$/, "")}%
              </td>
              {pathColumns.map((column) => (
                <td key={column.level} className={styles.cell}>
                  {formatSplitCostingPathCode(row, column.level)}
                </td>
              ))}
              <td className={styles.cell}>{formatDateCell(row.startDate)}</td>
              <td className={styles.cell}>{formatDateCell(row.endDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
